<rt-icons-container></rt-icons-container>

<div class="webapp-mock">
  <div class="webapp-mock-sidebar-menu">
    <div class="sidebar-items">
      <div>
        <div class="sidebar-item"></div>
        <div class="sidebar-item"></div>
        <div class="sidebar-item"></div>
        <div class="sidebar-item"></div>
      </div>
      <div>
        <div class="sidebar-item"></div>
        <div class="sidebar-item"></div>
        <div class="sidebar-item"></div>
      </div>
    </div>
  </div>

  <div class="webapp-mock-header-menu">
    <div class="header-wrapper">
      <div class="top-left">
        <div class="logo"></div>
      </div>
      <div class="top-center quick-search-container">
        <div class="search-input"></div>
      </div>
      <div class="top-right">
        <div class="header-item" margin-right-small></div>
        <div class="spacer" margin-right-small></div>
        <div class="header-item" margin-right-small></div>
        <div class="header-item" margin-right-small></div>
        <div class="header-item" margin-right-medium></div>
        <div class="header-item mock-avatar"></div>
      </div>
    </div>
  </div>

  <div class="app-content">
    <div class="content-wrap" layout-full-width>
      <div class="spinner-container">
        <rt-spinner *ngIf="loading"></rt-spinner>
      </div>

      <rtc-detached-router-outlet></rtc-detached-router-outlet>
    </div>
  </div>
</div>

<div class="fab-container">
  <div class="fab-new">
    <div></div>
  </div>
  <div class="fab-help">
    <div></div>
  </div>
</div>
